var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-form"},[_c('FormPanel',{attrs:{"data":_vm.store,"type":_vm.type,"business":_vm.business,"property":_vm.property}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }